import searchIcon from "../../assets/icon-search.svg";
import filterIcon from "../../assets/icon-filter.svg";
import filterIconActive from "../../assets/icon-filter-2.svg";
import IconSvg from "../IconSvg";
import {
  DropDownContainer,
  DropDownHeader,
  DropDownList,
  DropDownListContainer,
  FlexContainer,
  HorizontalStack,
  ListItem,
  VerticalStack
} from "./styles";
import { Input } from "../Input";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { animate, useAnimation, useMotionValue, motion } from "framer-motion";
import useComponentVisible from "../../hooks/useComponentVisible";
import favoriteIconNormal from "../../assets/icon-favorites.svg";
import favoriteIconActive from "../../assets/icon-favorites-active.svg";

interface QueryProps {
  pagination?: number;
  search?: string;
  filter?: string;
  search_key_word?: string;
}

interface ClausesDataProps {
  id: string;
  user_id: string;
  title: string;
  clause: string;
  description: string;
  is_favorite: boolean;
  key_words: string;
  created_at: string;
  updated_at: string;
}

interface SearchInputProps {
  search?: string;
  setSearch?: any;
  name?: string;
  type?: string;
  label?: string;
  query?: QueryProps;
  setQuery?: React.Dispatch<React.SetStateAction<QueryProps>>;
  focusInput?: boolean;
  setFocusInput?: React.Dispatch<React.SetStateAction<boolean>>;
  currentPage?: number;
  setCurrentPage?: React.Dispatch<React.SetStateAction<number>>;
  clausesData?: ClausesDataProps[];
  setClausesData?: React.Dispatch<React.SetStateAction<ClausesDataProps[]>>;
  filtered?: boolean;
  setFiltered?: React.Dispatch<React.SetStateAction<boolean>>;
  refresh?: boolean;
  setRefresh?: React.Dispatch<React.SetStateAction<boolean>>;
}

const category = [
  {
    name: "Favoritos",
    icon: "/images/icon-star-filter.svg",
    description: "ícone de favoritos",
    function: "favorite",
    iconActive: "/images/icon-star-filter-active.svg"
  }
];

const list = {
  visible: {
    opacity: 1,
    y: 5,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.3
    }
  },
  hidden: {
    opacity: 0,
    y: -20,
    transition: {
      when: "afterChildren"
    }
  }
};

const variants = {
  visible: (i: number) => ({
    opacity: 1,
    transition: {
      delay: i * 0.3
    }
  }),
  hidden: { opacity: 0 }
};

export const SearchInput = ({
  search,
  setSearch,
  label,
  name,
  type,
  query,
  setQuery,
  focusInput,
  setFocusInput,
  setCurrentPage,
  currentPage,
  clausesData,
  setClausesData,
  filtered,
  setFiltered,
  refresh,
  setRefresh
}: SearchInputProps) => {
  const controls = useAnimation();
  const x = useMotionValue(0);

  useEffect(() => {
    const controls = animate(x, 100, {
      type: "spring",
      stiffness: 2000
    });

    return controls.stop;
  });

  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const { ref, isComponentVisible, setIsComponentVisible } =
    useComponentVisible(true);

  const handleClick = useCallback(() => {
    setIsOpen(!isOpen);
    setIsComponentVisible(true);
  }, [isOpen, isComponentVisible]);

  const handleOptionFilter = useCallback(
    (type: string) => {
      if (type === "favorite") {
        setFiltered(true);
        setQuery(prevState => {
          return {
            ...prevState,
            filter: "favorite",
            category: ""
          };
        });

        setIsOpen(false);
      } else {
        setFiltered(false);
        setQuery(prevState => {
          return {
            ...prevState,
            filter: "",
            category: ""
          };
        });

        setIsOpen(false);
      }
    },
    [isOpen, query, filtered]
  );

  return (
    <FlexContainer>
      <IconSvg
        src={searchIcon}
        className="search-icon"
        description={"Pesquisar"}
      />

      <Input
        onChange={e => {
          setQuery({ ...query, search: e.target.value, pagination: 0 });
          setCurrentPage(0);
        }}
        value={query.search}
        name={name}
        label={label}
        placeholder={label}
        type={type}
        onFocus={() => setFocusInput(state => !state)}
        onBlur={() => setFocusInput(state => !state)}
      />
      <DropDownContainer ref={ref} onClick={handleClick}>
        <DropDownHeader Open={isOpen}>
          {query.filter === "favorite" && query.search_key_word === "" ? (
            <button
              style={{
                border: "none",
                cursor: "pointer",
                background: "transparent"
              }}
              onClick={() => handleOptionFilter("")}
            >
              <IconSvg
                src={favoriteIconActive}
                className="search-icon"
                description={"Filtrar"}
              />
            </button>
          ) : (
            <button
              style={{
                border: "none",
                cursor: "pointer",
                background: "transparent",
                width: "auto",
                height: "auto"
              }}
              onClick={() => handleOptionFilter("favorite")}
            >
              <IconSvg
                src={favoriteIconNormal}
                className="search-icon"
                description={"Filtrar"}
              />
            </button>
          )}
        </DropDownHeader>
      </DropDownContainer>
    </FlexContainer>
  );
};
